import React, { useState, useEffect } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from './logo.jpg'
import appimage from './multi_user_mode.jpeg'

const Emoji = props => (
  <span
    className="emoji"
    role="img"
    aria-label={props.label ? props.label : ""}
    aria-hidden={props.label ? "false" : "true"}
  >
    {props.symbol}
  </span>
);

function HomePage(props) {

  useEffect(() => {
    toast.success("Welcome to Pluto Office 🚀")

  }, [])

  return (
    <div className="App">
      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <header className="App-header">
        <h2>
          Welcome to Pluto Office
          <Emoji symbol="🚀" />
        </h2>
        <img src={logo} width={200} height={200} alt="Logo" />
        <img src={appimage} width={650} height={600} alt="Logo" />
        <br></br>
        <code> ✨ Our APP Homepage ✨. 👨‍💻 Development [🚧 In-Progress 🚧] </code>
        <br></br>
      </header>
    </div>
  );
}

export default HomePage;
